jQuery(function () { toggleMetaEventListener; });
jQuery(document).on('ajaxComplete', toggleMetaEventListener);
function toggleMetaEventListener() {
    jQuery('.fff-toggleMeta').off();
    jQuery('.fff-toggleMeta').on('click', function (e) {
        e.preventDefault();
        jQuery(this).siblings('.fff-toggleMetaTarget').slideToggle();
    });
}
jQuery(document).on('adding_to_cart', function (e, b) {
    jQuery(b).siblings('.fff-addingToCartLoader').css('visibility', 'visible');
});
jQuery(document).on('added_to_cart', function (e, b, c, d) {
    jQuery(d).siblings('.fff-addingToCartLoader').css('visibility', 'hidden');
});
jQuery(function () { fixedMenu; });
jQuery(window).on('resize', fixedMenu);
function fixedMenu() {
    if (!jQuery('.fff-fixedMenuElement').length) {
        return;
    }
    let element = jQuery('.fff-fixedMenuElement');
    let menu = jQuery('.fff-fixedMenuElement__menu');
    var offset = element.offset();
    let offsetBottom = offset.top + element.height();
    var menuHeight = jQuery('#primary-menu').height() + 60;
    if (jQuery(window).width() > 991) {
        let menuMaxWidth = 0.25 * element.width();
        menu.css('max-width', menuMaxWidth);
    }
    else {
        menu.css('max-width', '100%');
    }
    jQuery(document).on('scroll', function () {
        var scrollPos = jQuery(window).scrollTop();
        let menuOffset = menu.offset();
        let menuOffsetBottom = menuOffset.top + menu.height();
        if (element.hasClass('-fixedMenu')) {
            if (menuOffsetBottom > offsetBottom) {
                element.removeClass('-fixedMenu');
                menu.css('top', element.height() - menu.height() - 1);
            }
            else if (scrollPos < (offset.top - menuHeight)) {
                element.removeClass('-fixedMenu');
                menu.css('top', 0);
            }
        }
        else {
            if (scrollPos > (offset.top - menuHeight) && (scrollPos + menu.height() + menuHeight) < offsetBottom) {
                element.addClass('-fixedMenu');
                menu.css('top', menuHeight);
            }
        }
    });
}
(function ($) {
    $('form#mc-embedded-subscribe-form').on('submit', function () {
        if (!this.acceptance.checked) {
            alert('You need to accept our privacy policy');
            return false;
        }
        return true;
    });
    $('.fff-navbarIconLink.-searchToggle').on('click', function (e) {
        e.preventDefault();
        $('.mini-search.show-on-second-switch').toggleClass('-active');
    });
    $(document).on('ready ajaxComplete', function () {
        setTimeout(() => {
            $('.product-thumbnail, .fff-compareCartItemsBtn a').off();
            $('.product-thumbnail, .fff-compareCartItemsBtn a').on('click', function (e) {
                e.preventDefault();
                $('.woocommerce-cart-form__contents, .alg-wc-wl-view-table').toggleClass('-imgZoom');
            });
        }, 100);
    });
    $(document).on('js_event_wpv_pagination_completed', function () {
        $('html, body').animate({
            scrollTop: $("#content").offset().top
        }, 800);
    });
})(jQuery);
